import styled from 'styled-components';

export const Wrap = styled.div`
  position: relative;
  display: inline-flex;
  margin: 0 10px 0 0;
`;

export const Trigger = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 7px;
  height: 34px;
  padding: 0 11px;
  cursor: pointer;
  font-family: inherit;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.3px;
  border-radius: 10px;
  white-space: nowrap;
  color: #aab2b8;
  background: #161e23;
  border: 1px solid #2c353d;
  transition: color 0.15s ease, border-color 0.15s ease, background 0.15s ease;

  &:hover {
    color: #e6eaec;
    border-color: #3d4952;
    background: #1a2429;
  }
  &[aria-expanded='true'] {
    color: #e6eaec;
    border-color: #3d4952;
  }
`;

export const Flag = styled.img`
  width: 18px;
  height: 13px;
  border-radius: 2px;
  object-fit: cover;
  flex: none;
  display: block;
`;

export const Caret = styled.svg`
  width: 10px;
  height: 10px;
  flex: none;
  opacity: 0.7;
  transition: transform 0.18s ease;
  ${Trigger}[aria-expanded='true'] & {
    transform: rotate(180deg);
  }
`;

export const Menu = styled.div`
  position: absolute;
  right: 0;
  top: calc(100% + 8px);
  min-width: 172px;
  padding: 6px;
  z-index: 200;
  border-radius: 12px;
  background: #161e23;
  border: 1px solid #2c353d;
  box-shadow: 0 14px 34px rgba(0, 0, 0, 0.55);
`;

export const Item = styled.button`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 8px 10px;
  cursor: pointer;
  border: none;
  border-radius: 8px;
  font-family: inherit;
  font-size: 13px;
  text-align: left;
  color: #e6eaec;
  background: ${(props) => (props.$active ? 'rgba(71, 185, 114, 0.14)' : 'transparent')};
  transition: background 0.12s ease, color 0.12s ease;

  & + & {
    margin-top: 2px;
  }

  &:hover {
    background: ${(props) => (props.$active ? 'rgba(71, 185, 114, 0.18)' : '#1a2429')};
  }

  .native {
    color: ${(props) => (props.$active ? '#5cc98a' : 'inherit')};
    font-weight: ${(props) => (props.$active ? 600 : 400)};
  }

  .code {
    margin-left: auto;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.5px;
    color: ${(props) => (props.$active ? '#5cc98a' : '#7a838a')};
  }
`;
